import { render, staticRenderFns } from "./FilterPostcode.vue?vue&type=template&id=4dcfe6c4&"
import script from "./FilterPostcode.vue?vue&type=script&lang=js&"
export * from "./FilterPostcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports